import memoize from 'fast-memoize';
import { first } from '.';
import addOnKey from './addOnKey';
import packageKey from './packageKey';
import {
  packagePrice,
  packagePricePreTax,
  packagePriceTax
} from './packagePrice';

export const addOnsTotalsTax = memoize((sale, inventory) =>
  _addOnsTotals(sale, inventory, packagePriceTax)
);

export const addOnsTotalsPreTax = memoize((sale, inventory) =>
  _addOnsTotals(sale, inventory, packagePricePreTax)
);

export const addOnsTotals = memoize((sale, inventory) =>
  _addOnsTotals(sale, inventory, packagePrice)
);

const _addOnsTotals = (sale, inventory, _packagePrice) => {
  const { packages, packageAddOns } = sale;

  const inventoryPkgs = inventory.packages[packageKey(sale.day)] || [];

  let sum = 0;
  Object.keys(packages || {}).forEach(pkgId => {
    const pkg = first(inventoryPkgs, p => p.item_id == pkgId);
    if (pkg == null) return;

    const pkgCount = packages[pkgId].qty || 0;

    // price will be total since we send qty to accesso
    let price = _packagePrice(pkg, sale);
    price = parseFloat(price);
    sum += pkgCount == 0 ? 0 : price;

    Object.keys(packageAddOns[pkgId] || {}).forEach(addOnId => {
      const addOns = inventory.addOns[addOnKey(sale.day, pkg)];
      const addOn = first(addOns, addOn => addOn.item_id == addOnId);
      if (addOn == null) {
        return;
      }

      const addOnCount = (packageAddOns[pkgId] || {})[addOnId].qty || 0;

      if (addOn.free && addOn.addlPrice) {
        if (addOnCount > 1) {
          sum += (addOnCount - 1) * addOn.addlPrice;
        }
      }

      sum += addOnCount == 0 ? 0 : addOnCount * _packagePrice(addOn, sale);
      /*
      // price will be total since we send qty to accesso
      let addOnPrice = _packagePrice(addOn, sale);
      addOnPrice = parseFloat(price);
      sum += addOnCount == 0 ? 0 : addOnPrice;
      */
    });
  });

  return sum;
};

export const dealsTotals = memoize((sale, inventory) => {
  const { deals } = sale;

  let sum = 0;
  sum += addOnsTotals(sale, inventory);

  Object.keys(deals).forEach(dealId => {
    const deal = first(inventory.deals, deal => deal.item_id == dealId);
    const dealCount = deals[dealId] || 0;
    sum += dealCount == 0 ? 0 : dealCount * packagePrice(deal, sale);
  });

  return sum;
});
